function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  transition: opacity 0.3s;\n  z-index: 1;\n\n  &.profileDropdown-enter,\n  &.profileDropdown-exit.profileDropdown-exit-active {\n    opacity: 0;\n\n    ", " {\n      transform: scaleY(0);\n    }\n  }\n\n  &.profileDropdown-enter.profileDropdown-enter-active,\n  &.profileDropdown-exit {\n    opacity: 1;\n\n    ", " {\n      transform: scaleY(1);\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  transform-origin: top center;\n  transform: scaleY(1);\n  transition: transform 0.3s;\n  border-radius: 2px;\n  box-shadow: 0 2px 2px 0 rgba(76, 75, 75, 0.5);\n  background-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 10rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 11px;\n  border: 1px solid ", ";\n  text-transform: uppercase;\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.83;\n  padding: 0 0.5rem;\n\n  svg {\n    margin-left: auto;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../../theme";
export var UserProfileSelectWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.variables.typography.primaryFont;
});
export var UserProfileSelection = styled.div(_templateObject2(), function (props) {
  return props.theme.variables.colors.black;
}, function (props) {
  return props.theme.variables.fonts.size.smaller1;
}, function (props) {
  return props.theme.variables.fonts.weight.regular;
});
export var ProfileDisplayName = styled.div(_templateObject3());
export var UserProfileDropdownContent = styled.div(_templateObject4(), function (props) {
  return props.theme.variables.colors.white;
});
export var UserProfileDropdownContainer = styled.div(_templateObject5(), UserProfileDropdownContent, UserProfileDropdownContent);